import { __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import { Icon } from '@@Components/Icon/Icon';
import { ControllersGradientWrapper, Gradient, IconWrapper, TabButton, TabButtonWrapper, TabContent, TabsContainer, TabsHeader } from './styles';
const TabController = ({ last, onClick, disabled, active, title, narrow, noActiveBigFont, numbered, index }) => {
    return (React.createElement(TabButtonWrapper, { last: last },
        React.createElement(TabButton, { onClick: onClick, disabled: disabled, active: active, narrow: narrow, noActiveBigFont: noActiveBigFont },
            active && (numbered ? React.createElement("div", { className: "number" }, index + 1) : React.createElement(IconWrapper, null,
                React.createElement(Icon, { icon: 'active', width: 20, height: 20 }))),
            title)));
};
export const Tab = () => {
    return null;
};
export const Tabs = React.forwardRef((_a, ref) => {
    var _b, _c, _d;
    var { narrow = false, centered = false, noBorder = false, noActiveBigFont = false, numbered = false } = _a, props = __rest(_a, ["narrow", "centered", "noBorder", "noActiveBigFont", "numbered"]);
    const children = (_b = (props.children instanceof Array ? props.children : [props.children])) === null || _b === void 0 ? void 0 : _b.filter(Boolean);
    const [activeTab, setActiveTab] = useState(null);
    if (ref) {
        React.useImperativeHandle(ref, () => ({
            setActiveTab: (tabId) => {
                setActiveTab(tabId);
            }
        }), []);
    }
    useEffect(() => ((children === null || children === void 0 ? void 0 : children.length) <= activeTab) && setActiveTab(0), [children === null || children === void 0 ? void 0 : children.length]);
    useEffect(() => {
        var _a;
        if (props.onActiveTabChange) {
            const activeTitle = ((_a = children[activeTab]) === null || _a === void 0 ? void 0 : _a.props.title) || null;
            props.onActiveTabChange(activeTab, activeTitle);
        }
    }, [activeTab, children === null || children === void 0 ? void 0 : children.length]);
    useEffect(() => {
        if (typeof props.defaultOpened === 'number' && (props.defaultOpened < (children === null || children === void 0 ? void 0 : children.length))) {
            setActiveTab(props.defaultOpened);
        }
        else
            setActiveTab(0);
    }, [props.defaultOpened, children === null || children === void 0 ? void 0 : children.length]);
    const handleTabChange = (index) => {
        var _a, _b;
        setActiveTab(index);
        try {
            if ((_a = children[index]) === null || _a === void 0 ? void 0 : _a.props.onClick) {
                (_b = children[index]) === null || _b === void 0 ? void 0 : _b.props.onClick(index);
            }
        }
        catch (e) {
            console.log('handleTabChange: ', e);
        }
    };
    return (React.createElement(TabsContainer, null,
        React.createElement(ControllersGradientWrapper, null,
            React.createElement(TabsHeader, { centered: centered, noBorder: noBorder }, children === null || children === void 0 ? void 0 : children.map((child, index) => (React.createElement(TabController, { key: index, index: index, active: index === activeTab, title: child.props.title, last: index === (children === null || children === void 0 ? void 0 : children.length) - 1, disabled: child.props.disabled, narrow: narrow, centered: centered, numbered: numbered, noActiveBigFont: noActiveBigFont, onClick: () => handleTabChange(index) }, child.props.children)))),
            React.createElement(Gradient, null)),
        ((_c = children[activeTab]) === null || _c === void 0 ? void 0 : _c.props.children) && React.createElement(TabContent, null, (_d = children[activeTab]) === null || _d === void 0 ? void 0 : _d.props.children)));
});
